import type { Page, PartTypeInput, PartTypeListQuery, PartTypeView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { PartTypeInput, PartTypeView };

export function listPartTypes(query: PartTypeListQuery): Promise<Page<PartTypeView>> {
  return api<Page<PartTypeView>>(`/part-types?${toListParams(query)}`);
}

export function getPartType(id: string): Promise<PartTypeView> {
  return api<PartTypeView>(`/part-types/${id}`);
}

export function createPartType(input: PartTypeInput): Promise<PartTypeView> {
  return api<PartTypeView>('/part-types', { method: 'POST', body: JSON.stringify(input) });
}

export function updatePartType(id: string, input: PartTypeInput): Promise<PartTypeView> {
  return api<PartTypeView>(`/part-types/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivatePartType(id: string): Promise<void> {
  await api<unknown>(`/part-types/${id}/deactivate`, { method: 'POST' });
}

export async function reactivatePartType(id: string): Promise<void> {
  await api<unknown>(`/part-types/${id}/reactivate`, { method: 'POST' });
}
